(() => {
  'use strict';
  const body = document.body;
  if (!body) return;
  const fineTuneEnabled = body.dataset.zavoFxEnabled === 'true';
  const reduce = matchMedia('(prefers-reduced-motion: reduce)');
  const fine = matchMedia('(pointer:fine)');
  let spotlight = null, raf = null, x = -999, y = -999;

  if (fineTuneEnabled && body.dataset.zavoFxPointer === 'true' && fine.matches && !reduce.matches) {
    spotlight = document.createElement('div');
    spotlight.className = 'zavo-fx-spotlight';
    spotlight.setAttribute('aria-hidden','true');
    body.appendChild(spotlight);
    const draw = () => { raf = null; spotlight.style.setProperty('--zavo-fx-x', `${x}px`); spotlight.style.setProperty('--zavo-fx-y', `${y}px`); };
    addEventListener('pointermove', event => { x = event.clientX; y = event.clientY; spotlight.classList.add('is-active'); if (!raf) raf = requestAnimationFrame(draw); }, {passive:true});
    document.documentElement.addEventListener('mouseleave', () => spotlight.classList.remove('is-active'));
  }

  const excluded = [
    '.zhi__icon-button','.zhi__mobile-toggle','[data-zhi-close]','[data-zhi-search-close]',
    '.zcn__arrow','.zcn__dot','[class*="slider-button"]','[class*="pagination"]',
    '[class*="quantity"]','[class*="increment"]','[class*="decrement"]','[data-zavo-local-fx]','[aria-label*="schließen" i]','[aria-label*="close" i]'
  ].join(',');
  const candidates = [
    'a.button','button.button','button[type="submit"]','input[type="submit"]',
    '.shopify-payment-button__button','.zavo-max-button','.zavo-luxury-hero__button',
    '.zpc7-quick','.zcn__button','.zhi__cta','.zhi__mobile-cta','.zavo-editorial__button',
    '.zavo-manifesto__button','.zero-reviews__submit','.zds__button','.zpa__cta','.zsp-card__button','.zsp-follow__button',
    'a[class*="__button"]','button[class*="__button"]'
  ].join(',');

  const buttonFx = (scope = document) => {
    if (body.dataset.zavoButtonFx !== 'true') return;
    scope.querySelectorAll(candidates).forEach(el => {
      if (el.matches(excluded) || el.closest(excluded)) return;
      el.classList.add('zavo-global-button-fx');
    });
  };

  const magnetic = (scope = document) => {
    if (!fineTuneEnabled || body.dataset.zavoFxMagnetic !== 'true' || !fine.matches || reduce.matches) return;
    const strength = Number(body.dataset.zavoFxMagneticStrength) || 6;
    scope.querySelectorAll('.zavo-global-button-fx:not([data-zavo-magnetic])').forEach(el => {
      el.dataset.zavoMagnetic = 'true';
      el.addEventListener('pointermove', event => {
        const r = el.getBoundingClientRect();
        const dx = (event.clientX - r.left - r.width / 2) / r.width;
        const dy = (event.clientY - r.top - r.height / 2) / r.height;
        el.style.transform = `translate3d(${dx * strength}px,${dy * strength}px,0)`;
      });
      el.addEventListener('pointerleave', () => { el.style.transform = ''; });
    });
  };

  const boot = (scope = document) => { buttonFx(scope); magnetic(scope); };
  boot();
  document.addEventListener('shopify:section:load', event => boot(event.target));
})();
